<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-incorporate-confirm-dialog"
        top="10vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        :close-on-click-modal="false"
        width="350px"
    >
        <template slot="title">
            列入報表
        </template>
        <div class="container">
            <div class="description">
                確定要將 {{ selectedItems.length }} 張傳票列入，
                <span v-if="!!lastSettlementBelongDate">並重新結算</span> {{ year - 1911 }} 年度會計報表嗎？
            </div>
            <div v-if="!!lastSettlementBelongDate" class="settlement-date-select">
                <el-radio-group v-model="mergeSettlementDate">
                    <el-radio :label="true">列入上次結算日：{{ lastSettlementBelongDateText }}</el-radio>
                    <el-radio :label="false">以 {{ currentSettlementBelongDateText }} 結算</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="button-container">
            <el-button class="cancel-btn" :isLoading="isLoading" @click="$emit('close')">取消</el-button>
            <el-button v-if="!isQR()" type="primary" :isLoading="isLoading" @click="onConfirm"> 確定<span v-if="!!lastSettlementBelongDate">並重新結算</span> </el-button>
        </div>
    </el-dialog>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        purpose: {
            type: String,
            default: null,
        },
        year: {
            type: Number,
            default: null,
        },
        selectedItems: {
            type: Array,
            default: () => [],
        },
        lastSettlementBelongDate: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            mergeSettlementDate: true,
        };
    },
    computed: {
        lastSettlementBelongDateText() {
            return this.lastSettlementBelongDate ? `${moment(this.lastSettlementBelongDate).year() - 1911}/${moment(this.lastSettlementBelongDate).format('MM/DD')}` : null;
        },
        currentSettlementBelongDateText() {
            return `${moment().year() - 1911}/${moment().format('MM/DD')}`;
        },
    },
    methods: {
        async onBeforeClose() {
            this.$emit('close');
        },
        async onConfirm() {
            const settlementBelongDate = this.mergeSettlementDate ? this.lastSettlementBelongDate : +moment().startOf('day').format('x');
            try {
                await this.$api({
                    url: 'AccountingSummaryPage/ImportVouchersAndYearVoucher',
                    method: 'POST',
                    data: {
                        year: +this.$route.params.year,
                        settlementBelongDate,
                        voucherSnos: this.selectedItems.map((item) => item.sno),
                    },
                });
                this.$emit('close', true);
            } catch (e) {
                console.error(e);
            } finally {
                this.updateData();
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-incorporate-confirm-dialog {
    .container {
        padding: 30px 50px 0;
    }
    .button-container {
        display: flex;
        justify-content: center;
        padding: 20px 0 40px;
    }
    .settlement-date-select {
        padding: 20px 0;
    }
}
</style>
